export default polyfills;

function polyfills(next){
  const dependencies = [];

  if (!self.fetch) {
    dependencies.push(import('whatwg-fetch' /* webpackChunkName: 'whatwg-fetch' */));
  }

  if (!document.hasStorageAccess) {
    dependencies.push(StorageAccessAPI(document));
  }

  Promise.all(dependencies).then(next);
}

function StorageAccessAPI (document) {
  const stub = () => Promise.resolve(true);

  document.hasStorageAccess = document.requestStorageAccess = stub;
}
